import {
  DEFAULT_PREBID_LOAD_TIMEOUT,
  DEFAULT_AMAZON_LOAD_TIMEOUT,
  OLD_PREFIX,
  NEW_SUFFIX
} from '../constants';
import {
  showLog,
  showWarn
} from '../logger';

export default Object.preventExtensions({
  processConfig(configManager) {
    showLog('HBConfigManager:processConfig:Process HB config');
    _processPrebidConfig(configManager);
    _processAmazonConfig(configManager);
  }
});

/**
 * Process Prebid HB config to set dynamicId
 * @param {object} configManager
 */
function _processPrebidConfig(configManager) {
  var property, adUnits, newConfig, biddersDisabled;
  var {headerBidding} = configManager.configGDPMedio;

  showLog('HBConfigManager:processPrebidConfig:Process Prebid config');

  if (!headerBidding) {
    showLog('HBConfigManager:processPrebidConfig:There are not Prebid configuration');
    configManager.configGDPMedio.hbPrebid = null;
    return;
  }

  property = `adUnits_${configManager.deviceType}`;
  if (!(property in headerBidding) || !headerBidding[property].length) {
    showLog('HBConfigManager:processPrebidConfig:There are not bidders to device type', configManager.deviceType);
    configManager.configGDPMedio.hbPrebid = null;
    return;
  }

  // NOTE: 'disabled' key has the disabled bidders separated by comma
  biddersDisabled = [];
  if ('disabled' in headerBidding.biddersConfig) {
    biddersDisabled = headerBidding.biddersConfig.disabled.map(function(current) {
      return current.trim();
    });
  }

  adUnits = [];
  headerBidding[property].forEach((current) => {
    var position, newBids = [];

    position = current.code.replace(new RegExp(`(${OLD_PREFIX}|${NEW_SUFFIX})`, 'g'), '');
    if (!configManager.existePosEnConfigGDPMedio(position)) {
      showWarn(`HBConfigManager:processPrebidConfig:Position ${position} does not exists in configGDPMedio`);
      return;
    }
    if (!configManager.isActive({position})) {
      showWarn(`HBConfigManager:processPrebidConfig:Position ${position} is not active`);
      return;
    }

    current.code += configManager.dynamicId ? `-${configManager.dynamicId}` : '';

    if (biddersDisabled.length) {
      current.bids.forEach((bid) => {
        if (biddersDisabled.indexOf(bid.bidder) < 0) {
          newBids.push(bid);
        }
      });
    } else {
      newBids = current.bids;
    }

    if (!newBids.length) {
      showWarn(`HBConfigManager:processPrebidConfig:Remove adUnit ${current.code} because all bidders are disabled`);
      return;
    }

    current.bids = newBids;
    adUnits.push(current);
  });

  newConfig = {
    adUnits:           adUnits,
    biddersConfig:     headerBidding.biddersConfig,
    enableSendAllBids: headerBidding.enableSendAllBids,
    timeout:           headerBidding.timeout || DEFAULT_PREBID_LOAD_TIMEOUT
  };

  delete configManager.configGDPMedio.headerBidding;
  configManager.configGDPMedio.hbPrebid = newConfig;
}

/**
 * Process Amazon HB config to set dynamicId and slotName
 * @param  {object} configManager
 */
function _processAmazonConfig(configManager) {
  var property, slots, newConfig;
  var {hbAmazon} = configManager.configGDPMedio;

  if (!hbAmazon) {
    showLog('HBConfigManager:processAmazonConfig:There are not Amazon configuration');
    configManager.configGDPMedio.hbAmazon = null;
    return;
  }

  property = `slots_${configManager.deviceType}`;
  if (!(property in hbAmazon) || !hbAmazon[property].length) {
    showLog('HBConfigManager:processAmazonConfig:There are not slots to device type', configManager.deviceType);
    configManager.configGDPMedio.hbAmazon = null;
    return;
  }

  slots = [];
  hbAmazon[property].forEach((current) => {
    var position;

    position = current.slotID.replace(new RegExp(`(${OLD_PREFIX}|${NEW_SUFFIX})`, 'g'), '');
    if (!configManager.existePosEnConfigGDPMedio(position)) {
      showWarn(`HBConfigManager:processAmazonConfig:Position ${position} does not exists in configGDPMedio`);
      return;
    }
    if (!configManager.isActive({position})) {
      showWarn(`HBConfigManager:processAmazonConfig:Position ${position} is not active`);
      return;
    }

    current.slotName = _getAmazonSlotName(configManager, position);
    current.slotID   += configManager.dynamicId ? `-${configManager.dynamicId}` : '';
    slots.push(current);
  });

  newConfig = {
    slots:   slots,
    timeout: hbAmazon.timeout || DEFAULT_AMAZON_LOAD_TIMEOUT
  };

  configManager.configGDPMedio.hbAmazon = newConfig;
}

function _getAmazonSlotName(configManager, position) {
  var params;

  var container$ = $(`[data-voc-vam-position = '${position}']`, configManager.context$);
  if (container$.length) {
    params = configManager.normalizaParams(container$);
  } else {
    params = configManager.normalizaParams({position});
  }

  return configManager.getOasSitepage(params);
}



// WEBPACK FOOTER //
// ./src/header-bidding/config-manager.js